module.exports = __webpack_public_path__ + "static/media/05.52c8c627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/05.jpg
// module id = 312
// module chunks = 0